import { Alert } from '@/components';
import { getFormattedMessage } from '@/utils';

const ErrorRenderer = ({ error }) => {
  const errors = Array.isArray(error)
    ? error.filter(Boolean)
    : [error].filter(Boolean);

  if (errors.length === 0) return null;

  const messages = errors.map((error) => getFormattedMessage(error));

  return (
    <Alert type="danger">
      {messages.length === 1 ? (
        <span>{messages[0]}</span>
      ) : (
        <>
          {messages.map((msg, index) => (
            <>
              <span key={index}>{msg}</span>

              {index + 1 < messages.length ? <hr /> : null}
            </>
          ))}
        </>
      )}
    </Alert>
  );
};

export default ErrorRenderer;
